import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { Store } from '@ngrx/store';
import {
  selectHasUserDepartmentAccess,
  selectIsDepartmentStateLoaded,
} from '@shared/store/departments/departments.selectors';
import { filter, map, switchMap, take } from 'rxjs';

export const hasDepartmentAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);

  const clientCode = route.params.clientCode;
  const departmentId = +route.params.departmentId;

  return store.select(selectIsDepartmentStateLoaded(clientCode)).pipe(
    filter((isDepartmentStateLoaded) => isDepartmentStateLoaded),
    take(1),
    switchMap(() =>
      store.select(selectHasUserDepartmentAccess(clientCode, departmentId, authenticationService.user.id)),
    ),
    take(1),
    map((hasDepartmentAccess) => (hasDepartmentAccess ? true : router.createUrlTree(['/home']))),
  );
};
